import React from 'react'
import { Shield, RefreshCw, Truck, Award } from 'lucide-react'

const Feature = () => {
  const promises = [
    {
      icon: <RefreshCw className="w-8 h-8 lg:w-10 lg:h-10 text-[#B88E2F]" strokeWidth={1.5} />,
      title: "No Questions Asked Returns",
      desc: "MD Brothers EDU Promise",
    },
    {
      icon: <Award className="w-8 h-8 lg:w-10 lg:h-10 text-[#B88E2F]" strokeWidth={1.5} />,
      title: "Easy 7 Days Replacement",
      desc: "MD Brothers EDU Promise",
    },
    {
      icon: <Truck className="w-8 h-8 lg:w-10 lg:h-10 text-[#B88E2F]" strokeWidth={1.5} />,
      title: "FREE Shipping",
      desc: "MD Brothers EDU Promise",
    },
    {
      icon: <Shield className="w-8 h-8 lg:w-10 lg:h-10 text-[#B88E2F]" strokeWidth={1.5} />,
      title: "Easy Warranty Claim",
      desc: "MD Brothers EDU Promise",
    }
  ];

  return (
    <div className="h-auto py-10 lg:py-0 lg:h-[220px] bg-[#F9F1E7] mt-8 lg:mt-16 flex flex-col lg:flex-row items-center justify-evenly gap-8 lg:gap-4 px-6">
      {promises.map((feature, index) => (
        <div
          key={index}
          className="flex flex-col items-center lg:flex-row gap-3 lg:gap-4 max-w-[280px] text-center lg:text-left"
        >
          <div className="p-3 rounded-full bg-white shadow-sm flex-shrink-0">
            {feature.icon}
          </div>
          <div>
            <h3 className="font-bold text-[16px] lg:text-[18px] text-gray-900 leading-tight">
              {feature.title}
            </h3>
            <p className="text-[12px] lg:text-[14px] text-gray-500 mt-1">
              {feature.desc}
            </p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Feature